import { get, post, put, destroy, upload } from 'utils/fetchRequest';

// export const uploadImage = async (data) => {
//     try {
//         const result = await upload('files/comment', data);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

export const getMailList = async (searchText, page, pageLimit) => {
    try {
        const result = await get(
            `mails?1=1${searchText ? `&search=${searchText}` : ''}${page ? `&page=${page}` : ''}${pageLimit ? `&limit=${pageLimit}` : ''}`
        );

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const createMail = async (data) => {
    try {
        const result = await post('mails', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const sendMassMail = async (data) => {
    try {
        const result = await post('mails/mass', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const sendCode = async (data) => {
    try {
        const result = await post('mails/sendcode', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

export const confirmCode = async (data) => {
    try {
        console.log('updateCode', data);
        const result = await put('mail_confirm/1', data);

        return result;
    } catch (err) {
        return { error: err };
    }
};

// export const updateMenu = async (id, data) => {
//     try {
//         const result = await put(`menus/${id}`, data);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };

// export const deleteMenu = async (id) => {
//     try {
//         const result = await destroy(`menus/${id}`);

//         return result;
//     } catch (err) {
//         return { error: err };
//     }
// };
